import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Unstable_Grid2";
import ChangeTable from "../components/ChangeTable";

const ReceiptChange = (props) => {
  return (
    <Box>
      <Grid container>
        <Grid md={12}>
          <ChangeTable />
        </Grid>
      </Grid>
    </Box>
  );
};

export default ReceiptChange;
